module.exports = __webpack_public_path__ + "img/cert6.61e1186a.png";